import { Loader as CLoader } from '@consta/uikit/Loader';

export const Loader = ({ size = 'm', className = '' }: { size?: 's' | 'm'; className?: string }) => (
  <CLoader size={size} className={className} />
);
